<!-- `maximizeIcon` e `minimizeIcon` vêm em par: o PrimeNG renderiza
     `[ngClass]="maximized ? minimizeIcon : maximizeIcon"` e só entra nesse ramo quando
     `maximizeIcon` existe — definir um sem o outro deixaria o botão sem ícone no estado
     maximizado. O padrão (`window-maximize`) é um quadrado com seta saindo, igual ao de link
     externo, e era lido como "abrir em nova aba"; este par diz expandir/restaurar aqui mesmo. -->
<p-dialog
  header="Métricas dos apontamentos"
  [visible]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  maximizeIcon="pi pi-arrow-up-right-and-arrow-down-left-from-center"
  minimizeIcon="pi pi-arrow-down-left-and-arrow-up-right-to-center"
  appendTo="body"
  [baseZIndex]="10000"
  [breakpoints]="{ '768px': '96vw', '480px': '100vw' }"
  (onHide)="onHide()"
  [styleClass]="getDialogStyleClass()"
  [contentStyle]="{
    padding: '0',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: '0',
  }">
  <div class="metrics-content-wrapper">
    <app-time-entry-metrics [model]="model" (sliceActivate)="sliceActivate.emit($event)" />
  </div>

  <ng-template pTemplate="footer">
    <div class="form-actions">
      <p-button label="Fechar" icon="pi pi-times" severity="secondary" (onClick)="onHide()" />
    </div>
  </ng-template>
</p-dialog>
